export { default as entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';



// WEBPACK FOOTER //
// ./src/components/hoc/entityDetailEnhancer/index.ts